export const domainSkills = {
    "General": [
      "Adobe Creative Suite (Adobe Photoshop, Illustrator, InDesign, etc.)",
      "Typography",
      "Layout Design",
      "Color Theory",
      "Visual brand identities",
      "Illustration",
      "Custom graphics",
      "Image Editing and Retouching",
      "Print Design",
      "User Interface (UI) Design",
      "Web Design",
      "Information Design",
      "Wireframing",
      "Interaction Design",
      "Prototyping",
      "Adobe XD",
      "Sketch",
      "Figma",
      "InVision",
      "Heatmaps: Microsoft Clarity, Hotjar, Crazy Egg",
      "Data Analysis",
      "Google Analytics",
      "Mixpanel",
      "Responsive Design",
      "Accessibility Design",
      "Financial Statement Analysis",
      "Financial Ratio Analysis",
      "Financial Modeling",
      "Valuation Techniques",
      "Risk Analysis",
      "Capital Budgeting",
      "Cost Analysis",
      "Financial Forecasting",
      "Investment Analysis",
      "Corporate Finance",
      "Financial modeling software",
      "Statistical analysis software",
      "Data visualization tools"
    ],
    "App Development": [
      "React Native",
      "Flutter",
      "Xamarin",
      "Ionic",
      "SwiftUI",
      "NativeScript"
    ],
    "CyberSecurity": [
      "Network Security",
      "Network protocols",
      "Firewalls",
      "Intrusion detection systems (IDS) and Intrusion prevention systems (IPS)",
      "Virtual private networks (VPNs)",
      "Vulnerability Assessment",
      "Penetration Testing",
      "Incident Response"
    ],
    "IOT": [
      "Embedded Systems",
      "Raspberry Pi",
      "Arduino",
      "Wireless Protocols",
      "IoT Platforms"
    ],
    "Programming and Development": [
      "Amazon Web Services (AWS)",
      "Microsoft Azure",
      "Google Cloud Platform (GCP)",
      "IBM Cloud",
      "Cloud Infrastructure",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Serverless Computing",
      "AWS Lambda",
      "Azure Functions"
    ],
    "Data science and analytics": [
      "Data Cleaning",
      "Data Wrangling",
      "Data Visualization",
      "Statistical Modeling",
      "Predictive Modeling",
      "Machine Learning",
      "Deep Learning",
      "Big Data Technologies",
      "Data Warehousing"
    ],
    "Mobile Development": [
      "React Native",
      "Flutter",
      "Xamarin",
      "Ionic",
      "SwiftUI",
      "NativeScript"
    ],
    "Frontend Development": [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Angular",
      "Vue.js",
      "Sass/Less",
      "TypeScript",
      "Bootstrap",
      "Material-UI",
      "Tailwind CSS"
    ],
    "Backend Development": [
      "Node.js",
      "Express.js",
      "Ruby on Rails",
      "Django",
      "Flask",
      "ASP.NET",
      "Spring Boot",
      "Laravel"
    ],
    "Cloud Computing": [
      "Amazon Web Services (AWS)",
      "Microsoft Azure",
      "Google Cloud Platform (GCP)",
      "IBM Cloud",
      "Cloud Infrastructure",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Serverless Computing",
      "AWS Lambda",
      "Azure Functions"
    ],
    "Game Development": [
      "Unity",
      "Unreal Engine",
      "CryEngine",
      "Godot Engine"
    ],
    "Blockchain and Cryptocurrency": [
      "Blockchain Fundamentals",
      "Smart Contracts",
      "Decentralized Applications (DApps)",
      "Cryptocurrency Mining",
      "Crypto Wallets"
    ],
    "Artificial Intelligence": [
      "Machine Learning Algorithms",
      "Deep Learning Architecture",
      "Natural Language Processing (NLP)",
      "OpenCV",
      "TensorFlow",
      "PyTorch",
      "OpenAI Gym",
      "Stable Baselines",
      "RLlib"
    ],
    "Networking": [
      "Network Security",
      "Network protocols",
      "Firewalls",
      "Intrusion detection systems (IDS) and Intrusion prevention systems (IPS)",
      "Virtual private networks (VPNs)",
      "Vulnerability Assessment",
      "Penetration Testing",
      "Incident Response"
    ],
    "Operating System": [
      "Windows",
      "Linux",
      "macOS",
      "Unix"
    ],
    "Virtual Reality and Augmented Reality": [
      "Unity",
      "Unreal Engine",
      "CryEngine",
      "ARKit",
      "ARCore",
      "Vuforia"
    ],
    "Software Testing": [
      "Manual Testing",
      "Automated Testing",
      "Unit Testing",
      "Integration Testing",
      "System Testing",
      "Acceptance Testing",
      "Load Testing",
      "Performance Testing",
      "Security Testing"
    ],
    "Web Servers": [
      "Apache HTTP Server",
      "Nginx",
      "Microsoft IIS",
      "Tomcat"
    ],
    "Databases": [
      "Relational Databases",
      "NoSQL Databases",
      "Database Design",
      "SQL Query Optimization",
      "Database Administration",
      "Database Security"
    ],
    "Tech Entrepreneurship": [
      "Business Strategy",
      "Market Research",
      "Startup Fundraising",
      "Product Development",
      "Lean Startup Methodology",
      "Customer Development",
      "Sales and Marketing",
      "Business Model Canvas",
      "Pitch Deck Creation"
    ],
    "DevOps": [
      "Continuous Integration (CI)",
      "Continuous Deployment (CD)",
      "Configuration Management",
      "Containerization",
      "Orchestration Tools",
      "Monitoring and Logging",
      "Infrastructure as Code (IaC)",
      "Version Control Systems",
      "DevSecOps"
    ]
  }